import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getMacroConsumers = api(async function getMacroConsumers({ macroId } = {}) {
    if (!macroId) return []
    return query(
        gql`
            query GetMacroConsumers($macroId: String!) {
                getMacroConsumers(macroId: $macroId) {
                    id
                    macroId
                    consumerType
                    consumerId
                    ... on DraftConsumer {
                        draftTitle
                        draftCode
                        draftCreatedBy
                        draftProjectId
                        draftScheduleId
                    }
                }
            }
        `,
        { macroId },
        { returns: "getMacroConsumers" }
    )
})
